import(/* webpackMode: "eager" */ "/vercel/path0/app/projects/DonaUAM/page.tsx");
